const initialState = {
    fromPath: undefined,
};
var ACTION_TYPES;
(function (ACTION_TYPES) {
    ACTION_TYPES["HISTORY_FROM_PATH_UPDATE"] = "history/fromPath/update";
})(ACTION_TYPES || (ACTION_TYPES = {}));
export default function historyReducer(state = initialState, { type, payload }) {
    switch (type) {
        case ACTION_TYPES.HISTORY_FROM_PATH_UPDATE:
            return { ...state, fromPath: payload };
        default:
            return state;
    }
}
// action creators
export const historyFromPathUpdate = (payload) => ({
    type: ACTION_TYPES.HISTORY_FROM_PATH_UPDATE,
    payload,
});
// selectors
export const selectFromPath = (state) => state.history.fromPath;
